import React, { useEffect } from "react";
import {
  AiFillDollarCircle,
  AiOutlineShop,
  AiOutlineShoppingCart,
} from "react-icons/ai";
import { MdHomeRepairService } from "react-icons/md";

import Header from "./Header";
import { useNavigate } from "react-router-dom";
import { apiURL } from "../../api/index";

function Dashboard(props) {
  const Navigate = useNavigate();
  const adminDetails = JSON.parse(localStorage.getItem("adminDetails"));
  useEffect(() => {
    const DashboardPageLoaded = async () => {
      try {
        if (
          !adminDetails ||
          adminDetails.email === "" ||
          adminDetails.password === ""
        ) {
          Navigate("/admin");
        } else {
          const res = await fetch(
            `${apiURL}/admindashboard/${adminDetails.email}/${adminDetails.password}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          await res.json();
        }
      } catch (error) {
        Navigate("/admin");
      }
    };
    DashboardPageLoaded();
  }, [Navigate, adminDetails]);

  let totalSales = 0;
  let totalProducts = 0;
  let totalSalesServices = 0;
  let totalServices = 0;

  props.orders.forEach((item) => {
    // Remove the dollar sign and convert the string to a number
    const sales = parseInt(item.total.slice(1));
    totalSales += sales;
  });

  props.products.forEach((item) => {
    // Remove the dollar sign and convert the string to a number
    const products = item.quantity;
    totalProducts += products;
  });

  props.bookings.forEach((item) => {
    // Remove the dollar sign and convert the string to a number
    const sales = parseInt(item.total.slice(1));
    totalSalesServices += sales;
  });

  props.services.forEach((item) => {
    // Remove the dollar sign and convert the string to a number
    totalServices++;
  });

  return (
    <div className="dark:bg-dark" style={{ minHeight: "100vh" }}>
      <Header enableDarkMode={props.enableDarkMode} />
      {/* admin dashboard section flex*/}
      <div className="dark:bg-dark dark:text-white flex flex-col w-[88%] mx-auto bg-gray-100 p-3 mt-2">
        <h1 className="text-lg font-semibold pb-5 pt-5 md:text-left text-center">
          Admin Dashboard
        </h1>
        <div className="flex dark:text-dark md:flex-row flex-col md:h-auto h-[420px] justify-between items-center pb-5">
          <div className="admin-dashboard bg-white dark:bg-slate-600 dark:text-white rounded-xl pt-4 pb-4 px-10">
            <div>
              <AiOutlineShoppingCart size="50" color="green" />
            </div>
            <div className="text-lg pl-4 flex flex-col items-start">
              <div>Product Sales</div>
              <div className="font-bold">${totalSales}</div>
            </div>
          </div>
          <div className="admin-dashboard dark:bg-slate-600 dark:text-white bg-white rounded-xl pt-4 pb-4 px-10">
            <div>
              <AiFillDollarCircle size="50" color="orange" />
            </div>
            <div className="text-lg pl-4 flex flex-col items-start">
              <div>Booking Sales</div>
              <div className="font-bold">${totalSalesServices}</div>
            </div>
          </div>
          <div className="admin-dashboard dark:bg-slate-600 dark:text-white bg-white rounded-xl pt-4 pb-4 px-10">
            <div>
              <AiOutlineShop size="50" color="blue" />
            </div>
            <div className="text-lg pl-4 flex flex-col items-start">
              <div>Total Products</div>
              <div className="font-bold">{totalProducts}</div>
            </div>
          </div>
          <div className="admin-dashboard dark:bg-slate-600 dark:text-white bg-white rounded-xl pt-4 pb-4 px-10">
            <div>
              <MdHomeRepairService size="50" color="blue" />
            </div>
            <div className="text-lg pl-4 flex flex-col items-start">
              <div>Total Services</div>
              <div className="font-bold">{totalServices}</div>
            </div>
          </div>
        </div>
      </div>
      {/* admin dashboard latest order section */}
      <div className="flex dark:bg-dark dark:text-black p-3 flex-col w-[88%] mx-auto mt-2 bg-gray-100">
        <h1 className="md:text-left text-center dark:text-white pt-5 pb-5 font-semibold text-lg">
          Latest Orders
        </h1>
        <table className="w-full">
          <thead>
            <tr className="dark:bg-slate-800 dark:text-white bg-background text-gray-800">
              <th className="py-2 px-4 font-semibold">Buyer</th>
              <th className="py-2 px-4 font-semibold">Email</th>
              <th className="py-2 px-4 font-semibold">Items</th>
              <th className="py-2 px-4 font-semibold">Total</th>
              <th className="py-2 px-4 font-semibold">Status</th>
            </tr>
          </thead>
          <tbody className="dark:bg-slate-500 dark:text-white">
            {props.orders.map((order) => {
              return (
                <tr className="text-center" key={order._id}>
                  <td className="py-2 px-4">{order.buyer}</td>
                  <td className="py-2 px-4">{order.email}</td>
                  <td className="py-2 px-4">{order.items}</td>
                  <td className="py-2 px-4">{order.total}</td>
                  <td>
                    <button className="cursor-default py-1 px-4 bg-green-500 text-white rounded-sm">
                      Paid
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Dashboard;
